import { configureStore } from '@reduxjs/toolkit';
import stabilityAi from './apps/stabilityAi';
import nft from './apps/nft';
import auth from './apps/auth';
import transactionHistory from './apps/transactionHistory';

const store = configureStore({
  reducer: {
    auth,
    stabilityAi,
    nft,
    transactionHistory,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const AppDispatch = store.dispatch;
export const RootState = store.getState;

export const Redux = {
  getState: null, // Set the appropriate value or remove this line based on your implementation
  dispatch: AppDispatch,
};

export default store;
